import { render, staticRenderFns } from "./AulaButton.vue?vue&type=template&id=7f1311e4&scoped=true&"
import script from "./AulaButton.vue?vue&type=script&lang=js&"
export * from "./AulaButton.vue?vue&type=script&lang=js&"
import style0 from "./AulaButton.vue?vue&type=style&index=0&id=7f1311e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1311e4",
  null
  
)

export default component.exports